import { render, staticRenderFns } from "./ApprovalTask.vue?vue&type=template&id=61ca1837&"
import script from "./ApprovalTask.vue?vue&type=script&lang=js&"
export * from "./ApprovalTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports